/* eslint-disable no-shadow */
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import styles from '../../../resources/theme/global'
import {
  fetchTechnicalAbsencesRelatoryInit,
  makeRelatory,
  clearFilter,
} from '../TechnicalAbsencesRelatoryActions'
import { getTechnicalAbsencesRelatoryListData } from '../TechnicalAbsencesRelatoryReducer'

import Filter from './Filter'
import List from './List'
import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'

class TechnicalAbsencesRelatory extends Component {
  componentWillUnmount() {
    const { clearFilter } = this.props
    clearFilter()
  }

  makeReport = filters => {
    makeRelatory({ ...filters, withTrashed: true })
  }

  render() {
    const { classes, makeRelatory, filters } = this.props

    return (
      <BaseRelatoryPage title="Ausência de Técnicos">
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs={12}>
            <Filter classes={classes} />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <List {...this.props} />
        </Grid>
      </BaseRelatoryPage>
    )
  }
}

const mapStateToProps = state => ({
  ...getTechnicalAbsencesRelatoryListData(state),
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTechnicalAbsencesRelatoryInit,
      makeRelatory,
      clearFilter,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TechnicalAbsencesRelatory))
